import { render, staticRenderFns } from "./promotionEdit.vue?vue&type=template&id=67e93d3c&scoped=true&lang=html"
import script from "./promotionEdit.vue?vue&type=script&lang=js"
export * from "./promotionEdit.vue?vue&type=script&lang=js"
import style0 from "./promotionEdit.vue?vue&type=style&index=0&id=67e93d3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e93d3c",
  null
  
)

export default component.exports